export const COMPANY_NAME = 'HINDU BISWAKARMA COMMUNITY USA';
export const COMPANY_SHORT = 'HBC USA';
export const COMPANY_ADDRESS_FULL = '101 LAVENDER HILL DR, ETNA, OH 43062-7370';
export const COMPANY_LOCATION = 'Etna, Ohio';
export const COMPANY_TAGLINE = 'Heritage. Craft. Community.';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=101%20LAVENDER%20HILL%20DR%2C%20ETNA%2C%20OH%2043062-7370';

export const PILLARS = [
  {
    icon: 'heritage',
    label: 'Heritage',
    value: 'Biswakarma Tradition',
    note: 'Honoring the lineage of artisans, architects, and craftspeople rooted in Hindu tradition.',
  },
  {
    icon: 'community',
    label: 'Community',
    value: 'Families Across the USA',
    note: 'A public profile for families and friends connected by shared culture and faith.',
  },
  {
    icon: 'service',
    label: 'Service',
    value: 'Cultural Stewardship',
    note: 'Gathering, observance, and intergenerational learning kept at the center of the work.',
  },
  {
    icon: 'place',
    label: 'Place',
    value: COMPANY_LOCATION,
    note: 'A grounded postal presence supporting correspondence and directory listings.',
  },
];

export const COMMUNITY_FOCUS = [
  {
    step: '01',
    title: 'Heritage Stewardship',
    body: 'The community is presented as a public-facing organization preserving Biswakarma heritage — the craft, devotion, and lineage carried by its members.',
  },
  {
    step: '02',
    title: 'Cultural Gathering',
    body: 'The layout reflects the language of community: warm hospitality, observance, intergenerational learning, and a steady civic presence.',
  },
  {
    step: '03',
    title: 'Public-Safe Directory Data',
    body: 'The profile keeps the supplied postal address visible while private registry and tax identifiers remain out of the client page.',
  },
];

export const PUBLIC_INFO = [
  { label: 'Organization', value: COMPANY_NAME },
  { label: 'City / State', value: COMPANY_LOCATION },
  { label: 'Address', value: COMPANY_ADDRESS_FULL },
];
